import { render, staticRenderFns } from "./paginationComponent.vue?vue&type=template&id=287bd6b0&scoped=true&"
import script from "./paginationComponent.vue?vue&type=script&lang=js&"
export * from "./paginationComponent.vue?vue&type=script&lang=js&"
import style0 from "./paginationComponent.vue?vue&type=style&index=0&id=287bd6b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287bd6b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
